<template>
    <div class="form component-section">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h4 class="mb-0">Expedientes relacionados</h4>

            <div title="Crear ejecución de sentencia"
                 class="btn btn-primary btn-lg"
                 @click="setAction('expedient-detail-add-related-expedient-modal')"
                 v-if="hasSentenceStatus(expedient.statuses) && expedient.expedients.length === 0 && can('expedient.attach')">
                <span>Crear ejecución de sentencia</span>
            </div>
        </div>

        <div v-if="expedient.expedients?.length > 0">
            <div v-for="expedient in expedient.expedients"
                 :key="expedient.id">
                <div class="d-flex align-items-center justify-content-between">
                    <span class="badge bg-primary fs-6">{{ expedient.name }}</span>

                    <router-link class="btn btn-show" title="Mostrar expediente"
                                 :to="{ name: 'expedient.update', params: { expedient: expedient.id } }"
                                 v-if="can('expedient.update')">
                        <span class="uq-icon bi-search"></span>
                    </router-link>
                </div>

                <div>
                    <span class="badge bg-secondary fs-6">{{ expedient.contract_type_display }}</span>
                </div>

                <div v-if="expedient.form_values.tipo_procedimiento">
                    <span>Tipo '{{ expedient.form_values.tipo_procedimiento }}'</span>
                </div>
            </div>
        </div>

        <div v-else>
            <span class="content-text">No hay expedientes relacionados</span>
        </div>
    </div>

    <expedient-detail-add-related-expedient-modal v-if="modalToShow === 'expedient-detail-add-related-expedient-modal'"
                                                  :expedient="expedient"
                                                  @created="modalToShow = null; emitRelatedExpedientCreated()"
                                                  @closed="modalToShow = null;">
    </expedient-detail-add-related-expedient-modal>
</template>

<script>
import {can} from "../../../../helpers/Permissions";
import {hasSentenceStatus} from "../../../../helpers/Expedient";
import ExpedientDetailAddRelatedExpedientModal from "./ExpedientDetailAddRelatedExpedientModal";

export default {
    name: "ExpedientDetailRelatedExpedients",
    emits: ['related-expedient-created'],
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    components: {
        ExpedientDetailAddRelatedExpedientModal
    },
    setup() {
        return {
            can,
            hasSentenceStatus
        }
    },
    data() {
        return {
            modalToShow: null,
        }
    },
    async mounted() {
    },
    methods: {
        setAction(action) {
            this.modalToShow = action;
            this.status = action;
        },
        emitRelatedExpedientCreated() {
            this.$emit('related-expedient-created');
        },
    },
}
</script>
